import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { FormsModule } from '@angular/forms';
import { QBuiltInspectorConstants } from '../../models/constants/qbuilt-inspector.constants';
import { DropdownComponent } from '../dropdown/dropdown.component';
import { CommonModule } from '@angular/common';
import { FacilityDataModel } from 'src/app/modules/facility-config/models/facility-config.model';
import { FacilityConfigService } from 'src/app/modules/facility-config/services/facility-config.service';

@Component({
  selector: 'designate-station',
  template: `
    <div class="station-container" [ngClass]="{ disabled: !isEnabled }">
      <div class="designate-toggle">
        <div>
          <b>{{ toggleText }}</b>
        </div>
        <mat-slide-toggle
          [disabled]="!isEnabled"
          (change)="onToggleChange($event)"
        ></mat-slide-toggle>
      </div>
      <div [ngClass]="{ disabled: itemsDisabled }">
        <dropdown-component
          [dropdownType]="'station'"
          [stations]="stations"
          [disabled]="itemsDisabled"
          (stationSelected)="onStationChange($event)"
        ></dropdown-component>
        <div class="designate-btn-container">
          <div>
            <b>{{ designateBtnText }}</b>
          </div>
          @if (stationSelection) {
            <button class="designate-btn" (click)="designateTriggered()">
              {{ sendText }}
            </button>
          } @else {
            <button class="designate-btn-disabled" disabled>
              {{ sendText }}
            </button>
          }
        </div>
      </div>
    </div>
  `,
  styles: [
    `
      ::ng-deep
        .mat-mdc-slide-toggle.mat-mdc-slide-toggle-checked
        .mdc-switch__handle::after {
        background-color: var(--station-toggle) !important; 
      }

      .disabled {
        color: var(--qbuilt-grey);
      }
      .station-container {
        margin-left: 12px;
      }
      .designate-toggle {
        display: flex;
        align-items: center;
        gap: 8px;
        margin-bottom: 8px;
        margin-top: 20px;
      }
      .designate-btn-container {
        display: flex;
        align-items: center;

        .designate-btn {
          width: 120px;
          background-color: var(--save-button);
        }

        .designate-btn-disabled {
          width: 120px;
          background-color: var(--disabled-button);
        }
      }
    `,
  ],
  imports: [MatSlideToggle, FormsModule, DropdownComponent, CommonModule],
})
export class DesignateStationComponent {
  @Input() isEnabled: boolean = true;
  @Input() designate: boolean;
  @Input() stations: any[] = [];
  @Output() stationSelected = new EventEmitter<string>();
  @Output() designationTriggered = new EventEmitter<string>();

  itemsDisabled: boolean = true;

  stationSelection: string = '';

  toggleText: string = this.qbuiltInspConstants.toggleLabel;
  designateBtnText: string = this.qbuiltInspConstants.designateBtnText;
  sendText: string = this.qbuiltInspConstants.sendText;
  facilityNumber: string = sessionStorage.getItem('facilityNumber') || '';

  //session strorage keys
  cqmsSessionKey: string = this.qbuiltInspConstants.cqmsItemsKey;

  constructor(
    private qbuiltInspConstants: QBuiltInspectorConstants,
    private facilityConfigService: FacilityConfigService,
  ) {}

  ngOnInit() {
    let currentZone =
      JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}').zoneId ||
      null;
    this.facilityConfigService.getConfigurationData(this.facilityNumber);
    let sub = this.facilityConfigService.facilityData$.subscribe(
      (data: FacilityDataModel[]) => {
        if (data) {
          this.stations = []; // Clear before populating
          let possibleZones: any[] = [];
          data.forEach((zone) => {
            if (zone.Id > currentZone) {
              possibleZones.push(zone);
            }
          });
          possibleZones.forEach((zone) => {
            if (zone.Stations) {
              this.stations.push(...zone.Stations);
            }
          });
          this.stations = this.deduplicateStations(this.stations);
        }
      },
    );
  }

  deduplicateStations(list: any[]): any[] {
    const map = new Map();
    list.forEach((station) => {
      if (!map.has(station.Id)) {
        map.set(station.Id, station);
      }
    });
    return Array.from(map.values());
  }

  //User toggles designate toggle on/off
  onToggleChange(event: any) {
    this.designate = event.checked;
    this.itemsDisabled = !event.checked;
  }

  onStationChange(station: string) {
    this.stationSelection = station;
  }

  //Captures user selection of new station to designate defect to
  designateTriggered() {
    const cqmsSessionItems = sessionStorage.getItem(this.cqmsSessionKey)
      ? JSON.parse(sessionStorage.getItem(this.cqmsSessionKey) || '{}')
      : {};
    cqmsSessionItems.currentStationId = this.stationSelection;
    sessionStorage.setItem(
      this.cqmsSessionKey,
      JSON.stringify(cqmsSessionItems),
    );
    this.designationTriggered.emit(this.stationSelection);
  }
}
